import React, { Component } from "react";
import SharedViewProps from "../../../../shared/SharedViewProps";
import Service from "../../../../../network/Service";
import Application from "../../../../Application";
import RelaunchCheckDialogView from "./components/RelaunchCheckDialog";
import RelaunchCheckDialogState from "./components/RelaunchCheckDialog/state";

export default class RelaunchCheckView extends Component<SharedViewProps> {

    service = new Service();

    state = {
        error: undefined,
        queryParams: new URLSearchParams(this.props.routeProps.location.search)
    };

    render() {
        return (
            <RelaunchCheckDialogView onSubmit={this.onSubmit} error={this.state.error} />
        );
    }

    onSubmit = async (formData: RelaunchCheckDialogState, done: () => void) => {
        const checkId = this.state.queryParams.get('checkId');
        const superiorId = this.state.queryParams.get('superiorId');

        if (checkId && superiorId) {
            this.setState({ error: undefined });
            const { error } = await this.service.relaunchCheck(checkId, {
                superiorId: superiorId,
                comment: formData.comment
            });

            if (!error) {
                this.props.routeProps.history.push(`/${Application.language}/forms/submit-success`, {
                    origin: 'relaunch-check'
                });
            }

            else {
                this.setState({ error: 'genericError' });
                done();
            }
        }

        else {
            this.setState({ error: 'genericError' });
            done();
        }
    }
}